import { classNames } from 'shared/lib/classNames/classNames';
import { ReactNode } from 'react';
import cls from './Title.module.scss';

export enum TitleSize {
    title_20 = 'title_20',
    title_24 = 'title_24',
    title_32 = 'title_32',
    title_36 = 'title_36',
    title_50 = 'title_50',
    title_14_400 = 'title_14_400',
    title_20_400 = 'title_20_400',
    title_24_400 = 'title_24_400',
    title_30_400 = 'title_30_400',
    title_32_400 = 'title_32_400',
    title_36_400 = 'title_36_400',
}

interface TitleProps {
    className?: string
    children?: ReactNode
    positionCenter?: boolean
    size: TitleSize
    color: string
}

export const Title = ({ className, children, positionCenter, size, color }: TitleProps) => (
    <h2 className={classNames(cls.Title, { [cls.positionCenter]: positionCenter }, [className, cls[size]])} style={{ color }}>
        {children}
    </h2>
);
